import React from 'react';

interface NavbarProps {
  onSectionChange: (section: string) => void;
}

const Navbar: React.FC<NavbarProps> = ({ onSectionChange }) => {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-brand">
          <a 
            href="#home" 
            className="nav-logo"
            onClick={(e) => {
              e.preventDefault();
              onSectionChange('home');
            }}
          >
            Josh's Portfolio
          </a>
        </div>
        
        <div className="nav-links">
          <a 
            href="#home" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              onSectionChange('home');
            }}
          >
            HOME
          </a>
          <a 
            href="#work" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              onSectionChange('projects');
            }}
          >
            PROJECTS
          </a>
          <a 
            href="#about" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              onSectionChange('about');
            }}
          >
            ABOUT
          </a>
          <a 
            href="#contact" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              onSectionChange('contact');
            }}
          >
            CONTACT
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 